import { StyleSheet } from "aphrodite";

const Style = StyleSheet.create({
  containerStyle: {
    padding: "10px 8px",
    display: "flex",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "10px",
    },
  },
  rightStyle: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "@media (max-width: 768px)": {
      justifyContent: "center",
    },
  },
});

export default Style;
